<template>
  <v-card flat>
    <!-- component title -->    
    <template v-if="!$route.params.isApprentice">
      <h4>{{ $t("roles.title2") }}</h4>
      <ActionButton
        type="application"
        class="mt-4 mb-6"
        :isDisabled="!isAdmin($route.params.id)"
        @click="
          $nextTick(() => {
            $router.push({
              name: 'CompanyEmployeePermissions',
              params: { id: $route.params.id, employee_id: $route.params.employee_id },
            });
          })
        "
        actionIcon="$sl-user"
        >{{ $t("labels.show-person-role") }}</ActionButton
      >
    </template>
    <h4 class="mt-8">{{ $t("company.unlink-title") }}</h4>
    <p>{{ $t("company.unlink-text") }}</p>
    <ActionButton
      actionIcon="$sl-unlink"
      type="application"
      @click="$emit('delete', true)"
      class="mt-5"
      :isDisabled="isImitatingUser()"
      >{{ $t("company.unlink-title") }}</ActionButton
    >
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import API from "@/services/api.js";
import find from "lodash/find";
import ActionButton from "@/components/Common/ActionButton";
import { CompanyRoles } from "@/components/mixins";

// @group Company
// CompanyEmployeeList component
export default {
  name: "CompanyEmployeeList",

  mixins: [CompanyRoles],

  components: {
    ActionButton,
  },
  computed: {
    ...mapGetters("currentuser", [
      "currentUser",
      "isCompanyUser",
      "isApprentice",
      "isAdminUser",
      "isAdmin",
      "isImitatingUser",
    ]),
  },  
};
</script>

<style lang="scss"></style>
